import { Address } from '@rygen/rygen-ui/model';

export const renderAddressLines = (...addressLines: string[]): string => {
  return addressLines.join('\n');
};

const addLocalityPrefix = (address?: Address, output = ''): string => {
  if (address?.locality?.length) {
    return `${address?.locality}, ${output}`;
  }

  return output;
};

export const renderCityState = (address?: Address): string => {
  return addLocalityPrefix(address, address?.region);
};

export const renderCityStateZip = (address?: Address): string => {
  const regionAndPostal = [address?.region, address?.postalCode]
    .filter((val) => val?.length)
    .join(' ');

  return addLocalityPrefix(address, regionAndPostal);
};

export const renderFullAddress = (address?: Address): string => {
  const regionPostalAndCountry = [
    address?.region,
    address?.postalCode,
    address?.country,
  ]
    .filter((val) => val?.length)
    .join(' ');

  return addLocalityPrefix(address, regionPostalAndCountry);
};
